import { SitesBuilderLibComponent, Colormap } from '@3ddv/ngx-sites-builder-lib';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SbApiService } from 'src/app/sites-builder/services/sb-api.service';
import { SblibService } from '../../services/sblib.service';
import { ToolsService } from '../services/tools.service';
import { ColormapTemplate, default_colors } from './models/default.model';
import { TemplatesComponent } from './templates/templates.component';
import { CustomComponent } from './custom/custom.component';

@Component({
  selector: 'app-sbeditor-tool-colormap',
  templateUrl: './colormap.component.html',
  styleUrls: ['./colormap.component.scss'],
})
export class ColormapComponent implements OnInit, OnDestroy {
  // styles
  public master_default_colors: default_colors;
  public master_custom_colors: default_colors;
  public tool: Colormap;
  @ViewChild('templates') templatesChildrenComp: TemplatesComponent;
  @ViewChild('custom') customComponent: CustomComponent;

  public currenttab = {
    default: true,
    custom: false,
    templates: false,
  };
  private subscriptions: Array<Subscription>;
  public total_templates: number;

  constructor(
    private toolsService: ToolsService,
    private sblibService: SblibService,
    private toastrService: ToastrService,
    private apiService: SbApiService,
    private changeDetector: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute
  ) {
    // styles
    this.master_default_colors = {
      already_loaded: {
        section: false,
        seat: false,
        areaprice: false,
      },
      styles: [],
    };
    this.master_custom_colors = {
      already_loaded: {
        section: false,
        seat: false,
        areaprice: false,
      },
      styles: [],
    };
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      // console.log(res);
      if (res.colormap) {
        this.tool = res.colormap;
      } else {
        console.error('Colormap tool not found');
        return;
      }
    });
    this.subscriptions.push(tools$);

    const w$ = this.sblibService.sblib.asyncWorkflow$().subscribe(res => {
      this.initializeColors();
    });
    this.subscriptions.push(w$);

    this.total_templates = this.activatedRoute.snapshot.data.dataFlow.workflow.template_maps.length;
  }

  public ngAfterViewInit(): void {
    const w$ = this.sblibService.sblib.workflow$().subscribe(res => {
      this.initializeColors();
    });
    this.subscriptions.push(w$);
  }

  public refresh() {
    this.initializeColors();
  }

  public getTool() {
    if (this.currenttab.default) {
      this.tool.default = true;
      this.tool.manual = {};
    }
    if (this.currenttab.custom) {
      this.tool = this.customComponent.getTool();
    }
    // console.log(this.tool);
    return this.tool;
  }

  public initializeColors() {
    let initial_styles = JSON.parse(JSON.stringify(this.sblibService.sblib.defaultViewerStyles));
    if (initial_styles.length) {
      initial_styles = initial_styles[0];
    }

    this.setInitialStyles(initial_styles);

    if (!this.master_custom_colors.already_loaded.section) {
      if (this.tool.default || (this.tool.manual && !this.tool.manual.section)) {
        this.master_default_colors.styles.filter(s => {
          if (s.title === 'section') {
            this.master_custom_colors.styles.push(JSON.parse(JSON.stringify(s)));
            this.master_custom_colors.already_loaded.section = true;
          }
        });
      } else if (this.tool.manual && this.tool.manual.section) {
        const s = {
          title: 'section',
          styles: JSON.parse(JSON.stringify(this.tool.manual.section)),
        };
        this.master_custom_colors.styles.push(s);
        this.master_custom_colors.already_loaded.section = true;
      }
    }
    if (!this.master_custom_colors.already_loaded.seat) {
      if (this.tool.default || (this.tool.manual && !this.tool.manual.seat)) {
        this.master_default_colors.styles.filter(s => {
          if (s.title === 'seat') {
            this.master_custom_colors.styles.push(JSON.parse(JSON.stringify(s)));
            this.master_custom_colors.already_loaded.seat = true;
          }
        });
      } else if (this.tool.manual && this.tool.manual.seat) {
        const s = {
          title: 'seat',
          styles: JSON.parse(JSON.stringify(this.tool.manual.seat)),
        };
        this.master_custom_colors.styles.push(s);
        this.master_custom_colors.already_loaded.seat = true;
      }
    }
    if (!this.master_custom_colors.already_loaded.areaprice) {
      if (this.tool.default || (this.tool.manual && !this.tool.manual.areaprice)) {
        this.master_default_colors.styles.filter(s => {
          if (s.title === 'areaprice') {
            this.master_custom_colors.styles.push(JSON.parse(JSON.stringify(s)));
            this.master_custom_colors.already_loaded.areaprice = true;
          }
        });
      } else if (this.tool.manual && this.tool.manual.areaprice) {
        const s = {
          title: 'areaprice',
          styles: JSON.parse(JSON.stringify(this.tool.manual.areaprice)),
        };
        this.master_custom_colors.styles.push(s);
        this.master_custom_colors.already_loaded.areaprice = true;
      }
    }
    // console.log(this.master_default_colors);
  }

  private setInitialStyles(dvmstyles) {
    if (!this.master_default_colors.already_loaded.section && dvmstyles.section) {
      const s = {
        title: 'section',
        styles: JSON.parse(JSON.stringify(dvmstyles.section)),
      };
      this.master_default_colors.already_loaded.section = true;
      this.master_default_colors.styles.push(s);
    }
    if (!this.master_default_colors.already_loaded.seat && dvmstyles.seat) {
      const s = {
        title: 'seat',
        styles: JSON.parse(JSON.stringify(dvmstyles.seat)),
      };
      this.master_default_colors.already_loaded.seat = true;
      this.master_default_colors.styles.push(s);
    }
    if (!this.master_default_colors.already_loaded.areaprice && dvmstyles.areaprice) {
      this.master_default_colors.already_loaded.areaprice = true;
      const s = {
        title: 'areaprice',
        styles: JSON.parse(JSON.stringify(dvmstyles.areaprice)),
      };
      this.master_default_colors.styles.push(s);
    }
  }

  public customStyles() {
    this.currenttab = {
      default: false,
      custom: true,
      templates: false,
    };
  }

  public switchTab(tab) {
    this.currenttab = {
      default: false,
      custom: false,
      templates: false,
    };
    this.currenttab[tab] = true;
  }

  public copyDefaultToCustom(data_fromchild: default_colors) {
    this.master_custom_colors = JSON.parse(JSON.stringify(data_fromchild));
  }

  public onApplyTemplate(templatedb: any) {
    let template = JSON.parse(JSON.stringify(templatedb.values as ColormapTemplate));
    this.master_custom_colors = {
      already_loaded: {
        section: false,
        seat: false,
        areaprice: false,
      },
      styles: [],
    };

    if (template.section) {
      const style = {
        title: 'section',
        styles: template.section,
      };
      this.master_custom_colors.styles.push(style);
    }

    if (template.seat) {
      const style = {
        title: 'seat',
        styles: template.seat,
      };
      this.master_custom_colors.styles.push(style);
    }
  }

  public onTemplatesListUpdate(templates: Array<ColormapTemplate>) {
    this.total_templates = templates.length;
  }

  public onCreateTemplate(templatedb: ColormapTemplate) {
    const body = {
      name: templatedb.name,
      workflow_id: this.activatedRoute.snapshot.data.dataFlow.workflow.id,
      values: JSON.stringify(templatedb.values),
    };

    const u$ = this.apiService.createTemplateColormap(body).subscribe(res => {
      if (res) {
        console.log(res);
        const newtemplate = res.template_map;
        if (typeof newtemplate.values === 'string') {
          newtemplate.values = JSON.parse(newtemplate.values);
        }
        this.switchTab('templates');
        this.changeDetector.detectChanges();
        // Los templates vienen ordenados por fecha de modificación: le damos la vuelta para pushear
        let reversed = this.templatesChildrenComp.templates.reverse();
        reversed.push(newtemplate);
        // Le volvemos a dar la vuelta para que salga en el orden de creación correcto.
        this.templatesChildrenComp.templates = reversed.reverse();
        this.total_templates = this.templatesChildrenComp.templates.length;
        this.toastrService.success('', 'Success');
      }
    });
    this.subscriptions.push(u$);
  }
}
